export enum WidgetChartType {
    Pie = 'pie',
    Doughnut = 'doughnut',
    Bar = 'bar',
    Column = 'column',

    Line = 'line',
    Polar = 'polarArea',
    Area = 'area',
    Radar = 'radar',

    StackBar = 'stack-bar',
    StackColumn = 'stack-column'
}
